import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import type { DeepCamelCase } from '@/types/utils'
import { requiredString } from '@/utils/zod'

import type { SectionStatus } from '../constants/section-status'

type APIResponse = z.infer<typeof responseSchema>

const responseSchema = z.array(
  z.object({
    id: requiredString(),
    name: requiredString(),
    can_be_deleted: z.boolean()
  })
)

const parseResponse = (results: APIResponse): DeepCamelCase<APIResponse> =>
  results.map(item => ({
    id: item.id,
    name: item.name,
    canBeDeleted: item.can_be_deleted
  }))

type Params = {
  ids?: string[]
  courseIds?: string[]
  curriculumIds?: string[]
  statuses?: SectionStatus[]
}

export const useSectionsIds = (params: Params = {}) =>
  useQuery({
    queryKey: ['panelSectionsIdsList', params],
    staleTime: 60 * 1000,
    queryFn: async () => {
      const response = await httpService.panel.panelSectionsList({
        page: 1,
        page_size: 'max',
        id: params.ids,
        course_id: params.courseIds,
        curriculum_id: params.curriculumIds,
        status: params.statuses,
        fetchKeys: {
          id: true,
          name: true,
          can_be_deleted: true
        }
      })

      return parseResponse(responseSchema.parse(response.results))
    }
  })
